import React from "react";
import "./WhatsappButton.scss";

const WhatsappButton = () => {
  return (
    <a
      href="https://wa.me/525566176657"
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Enviar mensaje por WhatsApp"
    >
      <span className="whatsapp-button__icon">
        <svg
          viewBox="0 0 32 32"
          width="28"
          height="28"
          fill="currentColor"
        >
          <path d="M16.003 3.2c-7.064 0-12.8 5.736-12.8 12.8 0 2.255.589 4.46 1.706 6.402l-1.818 6.635 6.796-1.781c1.873 1.022 3.984 1.563 6.116 1.563h.005c7.062 0 12.797-5.736 12.797-12.8 0-3.42-1.332-6.637-3.75-9.055-2.417-2.418-5.634-3.764-9.052-3.764zm7.414 18.288c-.313.879-1.555 1.641-2.163 1.737-.554.086-1.277.123-2.061-.129-.474-.149-1.082-.355-1.868-.692-3.288-1.422-5.43-4.74-5.596-4.97-.167-.231-1.34-1.781-1.34-3.395 0-1.613.847-2.405 1.148-2.737.301-.331.655-.414.873-.414.218 0 .437.002.628.011.201.009.471-.076.737.562.277.667.941 2.303 1.023 2.47.083.166.138.36.028.58-.111.22-.166.359-.331.552-.166.193-.349.431-.497.579-.166.166-.338.346-.145.677.193.331.859 1.418 1.844 2.297 1.266 1.128 2.335 1.476 2.666 1.64.331.166.524.138.717-.083.193-.22.828-.965 1.049-1.296.22-.331.442-.276.746-.166.304.11 1.926.908 2.256 1.073.331.166.552.248.635.386.083.138.083.8-.23 1.679z" />
        </svg>
      </span>

      <span className="whatsapp-button__text">
        Cotizar ahora
      </span>
    </a>
  );
};

export default WhatsappButton;